/**
 * App-wide constants. Single source of truth for route paths and the API base,
 * so a path change is one edit, never a find-replace across components.
 */

/** The app is served under /app (see vite.config base + the server mount). */
export const BASE_PATH = '/app';

/** Route paths, relative to BASE_PATH (react-router basename handles the prefix). */
export const ROUTES = {
  login: '/login',
  signup: '/signup',
  forgot: '/forgot',
  reset: '/reset',
  verify: '/verify',
  account: '/account',
  billing: '/billing',
  bot: '/bot',
  dashboard: '/dashboard',
  trading: '/trading',
  strategy: '/strategy',
  history: '/history',
  botSettings: '/bot-settings',
  admin: '/admin',
} as const;

/** Mirror of the server rule (src/auth/passwords.ts). The server is the
 *  authority; this only lets a form warn before a round-trip. */
export const MIN_PASSWORD_LENGTH = 8;

/** Absolute URL for a route (used for redirects / links that leave the router). */
export const appUrl = (route: string): string => `${BASE_PATH}${route}`;

/**
 * Official $mallX Telegram links, supplied by the operator (17 Aug).
 *
 * These are Telegram JOIN links: the `+` prefix is the invite hash, so the
 * path must stay exactly as-is. They arrived written `t.me/\\+hash`; the
 * backslashes are an escaping artifact of the chat client (a backslash is not
 * legal in a t.me invite path and would break the link), so they are dropped.
 *
 * Kept here rather than inline so replacing an expired invite is one edit.
 */
export const TELEGRAM = {
  channel: 'https://t.me/+orTbL-jCa0oyMDAx',
  community: 'https://t.me/+b5K3Ax3kW4I0OTQx',
} as const;
